import { IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar } from "@ionic/react"

export const Toolbar = () => {
return(
    <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>Asistencia cliente</IonTitle>
        </IonToolbar>
      </IonHeader>
)
}